import { LocationMarker } from "./LocationMarker";

export default LocationMarker;
